export const UNCAUGHT_ERR = 'UNCAUGHT_ERR';
export const CLEAR_ERR = 'CLEAR_ERR';
export const CLEAR_ERR_AND_NAVIGATE_TO_HOME = 'CLEAR_ERR_AND_NAVIGATE_TO_HOME';

export function navigateToHome() {
  return { type: 'NAVIGATE', path: '/' };
}

export const uncaughtError = (err, info) => ({ type: UNCAUGHT_ERR, info, err });

export const clearError = () => ({ type: CLEAR_ERR });

export const clearErrAndGoToHome = () => ({ type: CLEAR_ERR_AND_NAVIGATE_TO_HOME });



// WEBPACK FOOTER //
// ./src/shells/ErrorComponent/actions.js